<div class="fixed inset-0 bg-slate-900/40 backdrop-blur-md z-[60] flex items-center justify-center p-4 transition-opacity duration-300 animate-fade-in"
    (click)="closeModalForm()">

    <!-- Modal Container -->
    <div (click)="$event.stopPropagation()"
        class="bg-white/95 dark:bg-slate-900/95 w-full max-w-3xl max-h-[90vh] rounded-[24px] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] border border-white/50 dark:border-slate-800/50 flex flex-col overflow-hidden backdrop-blur-xl animate-fade-in-up">

        <!-- Modal Header -->
        <div
            class="flex-none px-5 py-4 border-b border-slate-200/50 dark:border-slate-800/50 flex justify-between items-center bg-transparent gap-4">
            <div>
                <h2
                    class="text-lg md:text-xl font-black text-slate-800 dark:text-white flex items-center gap-3 tracking-tight">
                    <span class="material-icons text-amber-500 text-2xl">receipt_long</span>
                    ขอใบกำกับภาษีเต็มรูป
                </h2>
                <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5 font-medium">
                    กรอกข้อมูลเพื่อออกเอกสารใบกำกับภาษี</p>
            </div>
            <button (click)="closeModalForm()"
                class="w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 transition-colors shadow-sm cursor-pointer">
                <span class="material-icons text-xl">close</span>
            </button>
        </div>

        <!-- Modal Body -->
        <div class="flex-1 overflow-y-auto px-5 py-5 bg-slate-50/30 dark:bg-slate-900/30 relative custom-scrollbar space-y-5"
            (click)="closeDropdowns()">

            <!-- Type Selection -->
            <div>
                <label
                    class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">ประเภทผู้เสียภาษี</label>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <!-- Person -->
                    <button (click)="taxData.type = 0"
                        class="relative flex  items-center gap-3 p-3.5 border-2 rounded-xl cursor-pointer transition-all duration-300 text-left"
                        [ngClass]="taxData.type === 0 
                            ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 shadow-md shadow-amber-200/20' 
                            : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-amber-300 hover:shadow-sm'">
                        <div class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-300"
                            [ngClass]="taxData.type === 0 
                                ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' 
                                : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
                            <span class="material-icons text-xl">person</span>
                        </div>
                        <div>
                            <span class="text-[13px] font-bold block leading-tight"
                                [ngClass]="taxData.type === 0 ? 'text-amber-800 dark:text-amber-400' : 'text-slate-600 dark:text-slate-300'">บุคคลธรรมดา</span>
                            <span class="text-[11px] text-slate-400">Individual</span>
                        </div>
                        <div *ngIf="taxData.type === 0"
                            class="absolute top-5 right-3 w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center shadow-sm">
                            <span class="material-icons text-white text-[12px]">check</span>
                        </div>
                    </button>

                    <!-- Company -->
                    <button (click)="taxData.type = 1"
                        class="relative flex items-center gap-3 p-3.5 border-2 rounded-xl cursor-pointer transition-all duration-300 text-left"
                        [ngClass]="taxData.type === 1 
                            ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 shadow-md shadow-amber-200/20' 
                            : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-amber-300 hover:shadow-sm'">
                        <div class="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-300"
                            [ngClass]="taxData.type === 1 
                                ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' 
                                : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
                            <span class="material-icons text-xl">business</span>
                        </div>
                        <div>
                            <span class="text-[13px] font-bold block leading-tight"
                                [ngClass]="taxData.type === 1 ? 'text-amber-800 dark:text-amber-400' : 'text-slate-600 dark:text-slate-300'">นิติบุคคล
                                / บริษัท</span>
                            <span class="text-[11px] text-slate-400">Corporate</span>
                        </div>
                        <div *ngIf="taxData.type === 1"
                            class="absolute top-5 right-3 w-6 h-6  rounded-full bg-amber-500 flex items-center justify-center shadow-sm">
                            <span class="material-icons text-white text-[12px]">check</span>
                        </div>
                    </button>
                </div>
            </div>

            <!-- Basic Info Card -->
            <div
                class="bg-white dark:bg-slate-900 rounded-[20px] shadow-sm border border-slate-200/60 dark:border-slate-800 p-4 md:p-5 space-y-4">
                <h4
                    class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider flex items-center gap-1.5 pb-2 border-b border-slate-100 dark:border-slate-800">
                    <span class="material-icons text-[14px]">badge</span>
                    ข้อมูลผู้เสียภาษี
                </h4>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <!-- Full Name -->
                    <div class="col-span-1 md:col-span-2">
                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                            ชื่อ-นามสกุล / ชื่อบริษัท <span class="text-rose-500">*</span>
                        </label>
                        <input type="text" [(ngModel)]="taxData.fullName"
                            class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-amber-400 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200 placeholder:text-slate-400">
                    </div>

                    <!-- Tax ID -->
                    <div>
                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">
                            เลขประจำตัวผู้เสียภาษี <span class="text-rose-500">*</span>
                        </label>
                        <input type="text" [(ngModel)]="taxData.taxId" placeholder="13 หลัก" maxlength="13"
                            class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-amber-400 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200 font-mono tracking-wider placeholder:text-slate-400">
                    </div>

                    <!-- Phone -->
                    <div>
                        <label
                            class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">เบอร์โทรศัพท์</label>
                        <input type="tel" [(ngModel)]="taxData.phone" placeholder="081-234-5578" maxlength="10"
                            class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-amber-400 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200 placeholder:text-slate-400">
                    </div>

                    <!-- Email -->
                    <div class="col-span-1 md:col-span-2">
                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">อีเมล
                            (สำหรับจัดส่ง E-Tax Invoice)</label>
                        <input type="email" [(ngModel)]="taxData.email" placeholder="example@email.com"
                            class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-amber-400 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200 placeholder:text-slate-400">
                    </div>
                </div>
            </div>

            <!-- Branch Info (Juristic Only) -->
            <div *ngIf="taxData.type === 1"
                class="bg-amber-50/50 dark:bg-amber-900/10 border border-amber-200/60 dark:border-amber-800/30 rounded-xl p-4 animate-fade-in-up">
                <label class="flex items-center gap-2.5 mb-3 cursor-pointer group w-max">
                    <div class="relative flex items-center justify-center">
                        <input type="checkbox" id="hq" [(ngModel)]="taxData.headOffice" (change)="onHqChange()"
                            class="sr-only">
                        <div class="w-[18px] h-[18px] border-2 rounded-md flex items-center justify-center transition-all duration-300"
                            [ngClass]="taxData.headOffice 
                                ? 'bg-amber-500 border-amber-500 shadow-sm shadow-amber-500/25' 
                                : 'bg-white dark:bg-slate-800 border-slate-300 dark:border-slate-600 hover:border-amber-400'">
                            <svg class="w-3 h-3 text-white transition-transform duration-300" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"
                                [ngClass]="taxData.headOffice ? 'scale-100' : 'scale-0'">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                    </div>
                    <span
                        class="text-sm font-medium text-slate-700 dark:text-slate-300 select-none group-hover:text-amber-600 transition-colors">สำนักงานใหญ่
                        (Headquarters)</span>
                </label>

                <div *ngIf="!taxData.headOffice" class="grid grid-cols-1 md:grid-cols-2 gap-4 animate-fade-in">
                    <div>
                        <label
                            class="block text-xs font-medium text-slate-500 dark:text-slate-400 mb-1">ชื่อสาขา</label>
                        <input type="text" [(ngModel)]="taxData.branchName" placeholder="เช่น สาขาลาดพร้าว"
                            class="w-full px-3 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-amber-400 outline-none text-sm transition-all placeholder:text-slate-400">
                    </div>
                    <div>
                        <label class="block text-xs font-medium text-slate-500 dark:text-slate-400 mb-1">รหัสสาขา
                            (ถ้ามี)</label>
                        <input type="text" [(ngModel)]="taxData.branchNo" placeholder="เช่น 00001"
                            class="w-full px-3 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-amber-400 outline-none text-sm transition-all placeholder:text-slate-400 font-mono">
                    </div>
                </div>
            </div>

            <!-- Address Section Card -->
            <div
                class="bg-white dark:bg-slate-900 rounded-[20px] shadow-sm border border-slate-200/60 dark:border-slate-800 p-4 md:p-5 space-y-4">
                <h4
                    class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider flex items-center gap-1.5 pb-2 border-b border-slate-100 dark:border-slate-800">
                    <span class="material-icons text-[14px]">location_on</span>
                    ที่อยู่ตาม ภ.พ. 20 / บัตรประชาชน
                </h4>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <!-- Address -->
                    <div class="col-span-1 md:col-span-2">
                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">ที่อยู่
                            (เลขที่, หมู่บ้าน, ซอย, ถนน) <span class="text-rose-500">*</span></label>
                        <textarea [(ngModel)]="taxData.address" rows="2" placeholder="เลขที่, หมู่บ้าน, ซอย, ถนน"
                            class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-amber-400 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200 resize-none placeholder:text-slate-400 min-h-[60px]"></textarea>
                    </div>

                    <!-- Province -->
                    <div class="w-full">
                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">จังหวัด
                            <span class="text-rose-500">*</span></label>
                        <ng-container *ngTemplateOutlet="selectField; context: { 
                            label: 'จังหวัด', 
                            key: 'provinces', 
                            options: provinceOptions, 
                            selected: selectedProvinceId,
                            placeholder: '-- เลือกจังหวัด --'
                        }"></ng-container>
                    </div>

                    <!-- Amphure -->
                    <div class="w-full">
                        <label
                            class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">เขต/อำเภอ</label>
                        <ng-container *ngTemplateOutlet="selectField; context: { 
                            label: 'เขต/อำเภอ', 
                            key: 'amphures', 
                            options: amphureOptions, 
                            selected: selectedAmphureId,
                            placeholder: '-- เลือกอำเภอ --',
                            disabled: !selectedProvinceId
                        }"></ng-container>
                    </div>

                    <!-- Tambon -->
                    <div class="w-full">
                        <label
                            class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">แขวง/ตำบล</label>
                        <ng-container *ngTemplateOutlet="selectField; context: { 
                            label: 'แขวง/ตำบล', 
                            key: 'tambons', 
                            options: tambonOptions, 
                            selected: selectedTambonId,
                            placeholder: '-- เลือกตำบล --',
                            disabled: !selectedAmphureId
                        }"></ng-container>
                    </div>

                    <!-- Zip Code -->
                    <div>
                        <label
                            class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">รหัสไปรษณีย์</label>
                        <div
                            class="px-4 py-2.5 bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl outline-none text-slate-500 dark:text-slate-400 font-mono tracking-wider min-h-[46px] flex items-center">
                            {{ taxData.zipCode || '-' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="flex-none px-5 py-4 bg-white dark:bg-slate-900 border-t border-slate-200/50 dark:border-slate-800/50 flex justify-end gap-3"
            (click)="closeDropdowns()">
            <button (click)="closeModalForm()"
                class="px-5 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-slate-800 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors cursor-pointer">
                ยกเลิก
            </button>
            <button (click)="onSaveForm()" [disabled]="isLoading"
                class="cursor-pointer px-8 py-2.5 text-sm font-medium bg-amber-400 hover:bg-amber-500 text-amber-900 rounded-xl shadow-lg shadow-amber-400/30 transition-all transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none">

                <span *ngIf="!isLoading">ยืนยันขอใบกำกับภาษี</span>

                <div *ngIf="isLoading" class="flex items-center gap-2">
                    <svg class="animate-spin h-4 w-4 text-amber-900" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                        </circle>
                        <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                    </svg>
                    กำลังบันทึก...
                </div>
            </button>
        </div>
    </div>
</div>

<!-- Dropdown Template -->
<ng-template #selectField let-label="label" let-key="key" let-options="options" let-selected="selected" let-icon="icon"
    let-placeholder="placeholder" let-disabled="disabled">
    <div class="relative w-full" (click)="$event.stopPropagation()">
        <!-- Selected Value Display -->
        <button type="button" (click)="!disabled && toggleDropdown(key, $event)" [disabled]="disabled"
            class="w-full flex items-center justify-between px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl outline-none transition-all duration-200 group relative"
            [ngClass]="{
                'ring-2 ring-amber-400 border-transparent bg-white dark:bg-slate-700 shadow-sm': openDropdown === key,
                'hover:border-amber-300 dark:hover:border-amber-500 bg-white dark:bg-slate-800': !disabled && openDropdown !== key,
                'opacity-50 cursor-not-allowed bg-slate-100 dark:bg-slate-900': disabled,
                'cursor-pointer': !disabled
            }">

            <div class="flex items-center gap-2 overflow-hidden mr-6">
                <span *ngIf="icon"
                    class="material-icons-outlined text-[18px] text-slate-400 group-hover:text-amber-500 transition-colors">{{
                    icon }}</span>
                <span class="text-sm font-medium truncate"
                    [ngClass]="selected ? 'text-slate-800 dark:text-slate-100' : 'text-slate-400'">
                    {{ getOptionName(key, selected) || placeholder }}
                </span>
            </div>

            <!-- Arrow Icon -->
            <span class="material-icons text-[20px] text-slate-400 transition-transform duration-300 absolute right-3"
                [ngClass]="{ 'rotate-180 text-amber-500': openDropdown === key }">
                expand_more
            </span>
        </button>

        <!-- Dropdown Options -->
        <div *ngIf="openDropdown === key"
            class="absolute z-[100] mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.2)] border border-slate-100 dark:border-slate-700 py-1.5 animate-fade-in divide-y divide-slate-50 dark:divide-slate-700/50 max-h-60 overflow-y-auto custom-scrollbar">

            <div *ngIf="options.length === 0" class="px-4 py-8 text-center">
                <span class="material-icons-outlined text-slate-300 text-3xl mb-2">inventory_2</span>
                <p class="text-xs text-slate-400">ไม่มีข้อมูล</p>
            </div>

            <button *ngFor="let opt of options" type="button" (click)="selectOption(key, opt.value)"
                class="w-full flex items-center justify-between px-4 py-2.5 hover:bg-amber-50 dark:hover:bg-amber-900/20 text-left transition-colors group">
                <span class="text-sm font-medium transition-colors"
                    [ngClass]="selected === opt.value ? 'text-amber-600 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-300 group-hover:text-amber-600'">
                    {{ opt.label }}
                </span>
                <span *ngIf="selected === opt.value" class="material-icons text-amber-500 text-[18px]">check</span>
            </button>
        </div>
    </div>
</ng-template>